import { LoadingLayout } from 'components';
import { useNavigate } from 'libs/navigation';
import { useCreateDirectory } from 'modules/directory/createDirectoryRecord/hooks';
import { CreateDirectoryRecordView } from 'modules/directory/createDirectoryRecord/views';

export const CreateDirectoryRecordContainer = () => {
  const { params } = useNavigate<{ schemaId: string }>();

  const {
    fieldsConfig,
    validationSchema,
    onSubmit,
    directoryName,
    loadingSchemas,
    submitLoading,
  } = useCreateDirectory(params.schemaId!);

  if (loadingSchemas) {
    return <LoadingLayout />;
  }

  return (
    <CreateDirectoryRecordView
      directoryName={directoryName}
      fieldsConfig={fieldsConfig}
      initialValues={undefined}
      submitLoading={submitLoading}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    />
  );
};
